export default Object.freeze({
  Python: 'python',
});
